import React from 'react';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../api/logoutApi';
import handle_toast  from '../genericFunctions/toast_Handler';

const LogoutModal = ({onClose, isVisible}) => {  

    const dispatch = useDispatch();  

    if(!isVisible) return null;

    const handleLogin = async () => {
        try{            
            await logoutUser(dispatch);
            onClose();
        }
        catch(error){            
            handle_toast(error)
        }
    }

    return( 
        <div>
            <div className='modal-overlay'>
                <div className='modal-container' style={{'width': 'min-content'}}>
                    <div className='modal-header'>
                        <span>Session Expired</span>   
                    </div>
                    <div className='modal-body'>
                    <span>You have been logged out. Please login again. </span>
                    </div>
                    <div className='modal-footer'>
                        <se-button option="flat" color="primary" onClick={handleLogin}>Login</se-button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LogoutModal;